import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonDateModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonUIModule, CommonTranslationModule } from '@sdbn/common';
import { ListModule } from './list/list.module';
import { ConfirmDialogComponent } from './confirm-dialog/confirm.dialog.component';


@NgModule({
  declarations: [
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule,
    ApplicationClientCommonModule,
    CommonDateModule
  ],
  exports: [
    ListModule,
    CommonDateModule,
    CommonUIModule,
    CommonLayoutModule,
    ConfirmDialogComponent,
    CommonTranslationModule
  ]
})
export class SharedModule { }
